import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import { styled } from '@mui/material/styles'

export const Card = styled('section')(({ theme }) => ({
  position: 'relative',
  marginTop: theme.spacing(2),
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  background: 'linear-gradient(270deg, #1B5426 0%, #277634 100%)',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
  alignItems: 'flex-start',
  overflow: 'hidden',
  '& > :not(img)': {
    position: 'relative',
    zIndex: 1
  }
}))

export const Illustration = styled('img')({
  position: 'absolute',
  right: -10,
  top: 0,
  height: '100%',
  pointerEvents: 'none'
})

export const ActivatedRow = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  color: theme.palette.common.white
}))

export const ActivateButton = styled(Button)(({ theme }) => ({
  width: 'auto',
  paddingLeft: theme.spacing(2),
  height: 36,
  paddingRight: theme.spacing(2),
  color: theme.palette.common.white,
  backgroundColor: theme.palette.primary.main,
  boxShadow: '0px 2px 2px 0px rgba(0, 0, 0, 0.14)'
}))

export const ActivatedText = styled(Typography)({
  fontWeight: 700,
  color: 'inherit'
})
